import React from 'react'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import { ListingProvider } from '../../context/ListingContext'
import NotificationsPageContent from '../../components/NotificationsPageContent'
import Configuration from '../../Services/Api/Configuration'
import { LanguageConsumer } from '../../context/LanguageContext'

const Notifications = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Page.Notifications.title' })}
           pathname={window.location.origin + NamedRoutes.notifications}
           titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
           description={intl.formatMessage({ id: 'Page.Notifications.title' })}
      />

      <AccountLayout permission={Configuration.permissions.notification} content={
        <LanguageConsumer>
          {({ locale }) => (
            <ListingProvider entityName={'notification'} locale={locale}>
              <NotificationsPageContent locale={locale}/>
            </ListingProvider>
          )}
        </LanguageConsumer>
      }/>
    </>
  )
}

export default Notifications
